export const PASSWORD_VALIDATION_MESSAGE =
  'Password must have at least 8 characters, a lowercase letter, an uppercase letter, a number, and a special character'
export const EMAIL_PATTERN_MESSAGE = 'Enter your email correctly'
export const NO_EMPTY_EMAIL_MESSAGE = 'Email field is required'
export const NO_EMPTY_PASSWORD_MESSAGE = 'Password field is required'
